
import * as Contact from "./contactStyles";

export default function ContactContainer(){
    return (
        <div id="contact" data-aos="fade-up">
            <Contact.HeaderContainer>
                <Contact.HeaderTitle>03. Ways to contact me?</Contact.HeaderTitle>
                <Contact.HeaderSubTitle>
                    Drop a Line
                </Contact.HeaderSubTitle>
                <Contact.Description>
                   Hello! My inbox is always open. If you have a question or just want to say hello, I'll greatly appreciate it and do my best to reply. :)
                </Contact.Description>
                <Contact.EmailContainer>
                    <Contact.Email href="mailto:leuteriobrave@gmail.com" target="_blank">Say Hi</Contact.Email>
                </Contact.EmailContainer>
            </Contact.HeaderContainer>
        </div>

    )
}
